import { Menu, type MenuProps } from 'antd'

export type UiMenuProps = MenuProps

export default function UiMenu(props: UiMenuProps) {
  return <Menu {...props} />
}
